<template>
  <div class="registration-data-container">
    <div class="data-wrapper">
      <div class="header-container">
        <div class="profile-image">
          <img src="@/assets/img/profile-img.png" alt="default-profile-img" />
        </div>
        <div class="header-content-wrapper">
          <vue-audio class="recording" :file="getRegistrationData.recording" />
          <h3 class="name">{{ getFullname }}</h3>
          <div class="description-wrapper">
            <h4 class="gender">{{ getRegistrationData.gender }}</h4>
            <h4>•</h4>
            <h4 class="age">{{ getRegistrationData.age }} Tahun</h4>
          </div>
          <h4 class="domicile">{{ getRegistrationData.domicile }}</h4>
        </div>
        <div class="infaq-option">
          <p>Infaq {{ daftarPaket[getRegistrationData.pilihan_infaq - 1] }}</p>
        </div>
      </div>
      <div class="cards-container">
        <div class="cards">
          <h4 class="number">{{getRegistrationData.juz_number_memorized}}</h4>
          <p class="content">Jumlah juz yang dihafal</p>
        </div>
        <div class="cards">
          <h4 class="number">{{getRegistrationData.juz_target_number}}</h4>
          <p class="content">Target juz yang ingin dihafal</p>
        </div>
      </div>
      <label class="title">
        <strong>Pengalaman Tahsin</strong>
      </label>
      <p
        v-if="getRegistrationData.tahsin_experience == ''"
        class="tahsin-experience"
      >Belum ada pengalaman tahsin.</p>
      <div v-else class="tahsin-experience">
        <ul>
          <li
            v-for="(data, index) in getRegistrationData.tahsin_experience.split(',')"
            :key="index"
          >
            <p>{{ data }}</p>
          </li>
        </ul>
      </div>
      <p class="motivation">{{ getRegistrationData.motivation }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RegistrationData",
  props: {
    getRegistrationData: Object,
    getFullname: String
  },
  data() {
    return {
      daftarPaket: ["Paket Sendiri", "Paket Berdua", "Paket Bertiga"]
    };
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUserId: "getUserId",
      getUserRole: "getUserRole",
      getTermName: "getTermName",
      getHasProgramRegistered: "getHasProgramRegistered"
    })
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 768px) {
  .registration-data-container {
    .header-container {
      display: flex !important;
      flex-direction: column;

      .profile-image {
        order: 1;
      }

      .infaq-option {
        order: 2;
        margin: auto;
      }

      .header-content-wrapper {
        order: 3;
      }
    }

    .name {
      text-align: center;
    }

    .description-wrapper {
      align-items: center;
      justify-content: center;
    }

    .domicile {
      text-align: center;
    }
  }
}

.registration-data-container {
  .data-wrapper {
    display: flex;
    flex-direction: column;
  }

  .description-wrapper {
    display: flex;
    flex-wrap: wrap;

    h4 {
      margin-right: $gap-sm-2;
      font-size: 18px;
      font-weight: lighter;
    }
  }

  .header-container {
    display: grid;
    grid-template-columns: 128px 1fr;
    gap: $gap-sm-2;
    margin-bottom: $gap-m-2;

    .header-content-wrapper {
      display: flex;
      flex-direction: column;
    }
  }

  .recording {
    margin: auto;
  }

  .gender {
    font-weight: bold;
  }

  .domicile {
    margin-top: $gap-sm-2;
    text-transform: capitalize;
    font-size: 16px;
    font-weight: lighter;
    color: #aaa;
  }

  .profile-image {
    align-self: center;
    max-width: 128px;
    max-height: 128px;
    background: $white;
    border-radius: 20px;

    img {
      max-width: inherit;
      max-height: inherit;
    }
  }

  .name {
    text-transform: capitalize;
    font-weight: bold;
    color: $primary;
  }

  .infaq-option {
    background: $secondary;
    padding: $gap-sm-1 $gap-sm-2;
    border-radius: 20px;

    p {
      font-size: 11px;
    }
  }

  p.tahsin-experience {
    text-align: center;
  }

  div.tahsin-experience {
    margin: $gap-sm-2;
    display: flex;
    align-items: center;
    justify-content: center;

    ul {
      display: flex;
      flex-wrap: wrap;
      text-decoration: none;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    li {
      background: $white;
      border-radius: 5px;
      padding: $gap-sm-1 $gap-m-2;
      margin: $gap-sm-1;
    }
  }

  .title {
    text-align: center;
    margin-top: $gap-sm-2;
  }

  .motivation {
    margin: $gap-m-2;
    font-weight: lighter;
    text-align: center;
    font-style: italic;

    &::before {
      content: '"';
    }

    &::after {
      content: '"';
    }
  }

  .cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  .cards {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    white-space: pre-wrap;
    box-shadow: 0 0 6px $white;
    padding: $gap-m-2;
    margin: $gap-sm-2;
    border-radius: 20px;
    border: 1px solid $primary;

    .number {
      font-size: 32px;
    }

    .content {
      margin-top: $gap-sm-2;
      text-align: center;
    }
  }
}
</style>
